export default "__VITE_ASSET__D996PLdE__"